import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, Inject } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { Store } from '@ngrx/store';
import { take, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IOtpConfig } from '../../models/otp-config.model';
import * as forgotPasscodeVerifySelector from '../../selectors/forgot-passcode-verify.selectors';
import { IForgotPasscodeVerifyResponse, IVerifyOTPRequest } from '../../models/forgot-passcode-verify.model';
import { IOtpRequest } from '../../../../core/models/otp.model';
import * as forgotPasscodeSelector from '../../selectors/forgot-passcode.selectors';
import { ICheckRegisterRequiredRequest } from '../../../../core/models/check-registration.model';
import * as forgotPasscodeLoginConfirm from '../../actions/forgot-passcode-login-confirm.actions';
import * as forgotPasscodeLoginConfirmSelector from '../../selectors/forgot-passcode-login-confirm.selectors';
import * as forgotPasscodeResendOtpActions from '../../actions/forgot-passcode-resend-otp.actions';
import { IForgotPasscodeResentOtpRequest, IForgotPasscodeResentOtpResponse } from '../../models/forgot-passcode-resend-otp.model';
import * as validatePassGovIdSelector from '../../selectors/validate-gov-id-passport.selectors';
import { IValidateGovIdPassortRequest } from '../../models/validate-gov-id-passport.model';
import { IRegistrationLoginSuccess } from '../../models/registration-login.model';
import * as loginSelector from '../../selectors/login.selectors';
import { APP_CONFIG } from '../../../../config/app-config.module';
import { AppConfig } from '../../../../core/config-models/app-config.model';
import { RouteURL } from '../../../../shared/enums';
import * as forgotPasscodeOTPActions from '../../actions';
import { SharedService } from '../../../../shared/shared.service';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-passcode-otp',
  templateUrl: './forgot-passcode-otp.component.html',
  styleUrls: ['./forgot-passcode-otp.component.css']
})
export class ForgotPasscodeOtpComponent implements OnInit, OnDestroy, OnChanges {
  otpConfig: Partial<IOtpConfig>;
  countDownTimer$: Observable<number>;
  subscription: Subscription = new Subscription();
  forgotPasscodeVerifyResponse$: Observable<IForgotPasscodeVerifyResponse>;

  forgotPasscodeOtpResponse$: Observable<IForgotPasscodeResentOtpResponse>;
  loginResponse$: Observable<IRegistrationLoginSuccess>;

  validatePassGovIdRequest$: Observable<IValidateGovIdPassortRequest>;
  getUserMobileData$: Observable<ICheckRegisterRequiredRequest>;
  userMobileNumber: string;
  tick: number;
  otpTimer: number;
  sendOtpToMobilePhone: boolean;
  countryId: string;
  governmentIdNumber: string;
  hasEmailAddress: boolean;
  enterOtp: boolean;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;

  resendOtpToMobileMethod: string = 'C4C0C190-7D76-45A7-88A4-BE7ADD2869DC';
  resendOtpToEmailMethod: string = 'D3BEC764-EC4B-43D9-961B-DF990D6B024E';
  resendOtpToWhatsAppMethod: string = '242D8F87-341F-4576-950F-923B596D7DB8';
  otpRequestMethod: string = 'A WhatsApp';
  subdomain: string;
  emailForm = this.fb.group({
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private router: Router,
    private store: Store,
    private fb: UntypedFormBuilder,
    public sharedService: SharedService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    sharedService.forgotPasscodeIsOTP = true;
    this.subdomain = this.sharedService.getSubDomain();
    this.loginResponse$ = this.store.select(loginSelector.getLoginSuccess);

    this.forgotPasscodeVerifyResponse$ = this.store.select(forgotPasscodeVerifySelector.getForgotPasscodeVerifyResponse);
    this.forgotPasscodeOtpResponse$ = this.store.select(forgotPasscodeLoginConfirmSelector.getForgotPasscodeVerifyResponse);
    this.validatePassGovIdRequest$ = this.store.select(validatePassGovIdSelector.getValidateGovIdPassportRequest);

    this.tick = 1000;
    this.otpTimer = this.sharedService.forgotPasscodeResendOTPAfter?this.sharedService.forgotPasscodeResendOTPAfter:30;
    this.enterOtp = true;
    this.otpConfig = {
      length: 6,
      allowNumbersOnly: true,
      inputStyles: {
        'border-left': 'none',
        'border-top': 'none',
        'border-right': 'none',
        'border-bottom': '1px solid',
        outline: 'none',
        'border-bottom-left-radius': '0px',
        'border-bottom-right-radius': '0px'
      }
    };

    this.getUserMobileData$ = this.store.select(forgotPasscodeSelector.getForgotPasscodeUserNeedsHelpRequest);
    this.sendOtpToMobilePhone = false;
  }

  ngOnInit(): void {
    if(!(this.sharedService.forgotPasscodeDialingCode && this.sharedService.forgotPasscodeMobileNumber)){
      this.router.navigateByUrl(RouteURL.AUTH_MOBILE_SUBMIT);
    }

    this.startCountTimer();
    this.subscription.add(
      this.forgotPasscodeVerifyResponse$.subscribe(response => {
        if (response !== undefined) {
          this.hasEmailAddress = response.userHasEmailAddress;
          this.otpTimer = response.secondsUntilNextOtpSendAllowed;
        }
      })
    );

    this.subscription.add(
      this.getUserMobileData$.subscribe(userDetails => {
        if (userDetails !== undefined) {
          this.userMobileNumber = userDetails.mobileNumber;
        }
      })
    );

    this.subscription.add(
      this.validatePassGovIdRequest$.subscribe(vals => {
        if (vals !== undefined) {
          this.countryId = vals.countryOfIssueId;
          this.governmentIdNumber = vals.identityNumber;
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.subscription.add(
      this.forgotPasscodeOtpResponse$.subscribe(vals => {
        if (vals !== undefined) {
          this.otpTimer = vals.secondsUntilNextOtpSendAllowed;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onOtpChange(otpDigits: string) {
      const req: IVerifyOTPRequest = {
        dialingCode: this.sharedService.forgotPasscodeDialingCode,
        mobileNumber: this.sharedService.forgotPasscodeMobileNumber,
        otp: otpDigits
      };

      if (otpDigits.length === 6 && this.enterOtp) {
        this.enterOtp = false;
        this.store.dispatch(
          forgotPasscodeOTPActions.fromForgotPasscodeVerifyActions.verifyOTP({
            request: req
          })
        );
      } else if (otpDigits.length < 6) {
        this.enterOtp = true;
      }
  }

  resendOtp(val) {
    var resendOtpTo = '';
    switch(val){
      case 1:
        this.otpRequestMethod = 'A WhatsApp';
        resendOtpTo = this.resendOtpToWhatsAppMethod;
      break;
      case 2:
        this.otpRequestMethod = 'A SMS';
        resendOtpTo = this.resendOtpToMobileMethod;
        break;
      case 3:
        this.otpRequestMethod = 'An email';
        resendOtpTo = this.resendOtpToEmailMethod;
        break;
      default:
        this.otpRequestMethod = 'A WhatsApp';
        resendOtpTo = this.resendOtpToWhatsAppMethod;
        break;
    }

    this.ngOtpInputRef.setValue('');
    this.otpTimer = this.sharedService.forgotPasscodeResendOTPAfter?this.sharedService.forgotPasscodeResendOTPAfter:30;
    this.enterOtp = true;
    this.store.dispatch(forgotPasscodeResendOtpActions.clearForgotPasscodeResendOtp());
    this.startCountTimer();

    if(val==3){
      if(this.sharedService.forgotPasscodeIsUserEmailVerified){
        this.store.dispatch(
          forgotPasscodeOTPActions.fromResendActions.resendOtpRequest({
            request: {
              dialingCode: this.sharedService.forgotPasscodeDialingCode,
              mobileNumber: this.sharedService.forgotPasscodeMobileNumber,
              emailAddress: this.emailForm.value.email,
              resendOTPMethod: resendOtpTo
            }
          })
        );
      }else{
       this.sharedService.forgotPasscodeIsOTP = this.sharedService.forgotPasscodeIsUserEmailVerified;
      }
    }else{
      this.store.dispatch(
        forgotPasscodeOTPActions.fromResendActions.resendOtpRequest({
          request: {
            dialingCode: this.sharedService.forgotPasscodeDialingCode,
            mobileNumber: this.sharedService.forgotPasscodeMobileNumber,
            emailAddress: undefined,
            resendOTPMethod: resendOtpTo
          }
        })
      );
    }
  }

  startCountTimer() {
    this.countDownTimer$ = timer(0, this.tick).pipe(
      take(this.otpTimer),
      map(() => --this.otpTimer)
    );
  }

  navBackBtn() {
    this.router.navigateByUrl(RouteURL.AUTH_MOBILE_SUBMIT);
  }

  submitEmail() {
    if (this.emailForm.value.email) {
      this.store.dispatch(
        forgotPasscodeOTPActions.fromResendActions.resendOtpRequest({
          request: {
            dialingCode: this.sharedService.forgotPasscodeDialingCode,
            mobileNumber: this.sharedService.forgotPasscodeMobileNumber,
            emailAddress: this.emailForm.value.email,
            resendOTPMethod: this.resendOtpToEmailMethod
          }
        })
      );
    }
  }
}
